export function cropAndCompressImage(
  file: File,
  maxSizeMB: number = 10,
  outputWidth: number = 1000,
  outputHeight: number = 1000,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          reject(new Error('Impossibile ottenere il contesto 2D del canvas.'));
          return;
        }

        const cropSize = Math.min(img.width, img.height);
        const cropX = (img.width - cropSize) / 2;
        const cropY = (img.height - cropSize) / 2;

        ctx.drawImage(img, cropX, cropY, cropSize, cropSize, 0, 0, outputWidth, outputHeight);

        let quality = 0.95;

        const compress = () => {
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error('Errore durante la compressione.'));
                return;
              }

              const sizeMB = blob.size / 1024 / 1024;
              if (sizeMB <= maxSizeMB || quality <= 0.1) {
                resolve(blob);
              } else {
                quality -= 0.05;
                compress();
              }
            },
            'image/jpeg',
            quality,
          );
        };

        compress();
      };

      img.onerror = () => reject(new Error("Errore nel caricamento dell'immagine."));
      img.src = reader.result as string;
    };

    reader.onerror = () => reject(new Error('Errore nella lettura del file.'));
    reader.readAsDataURL(file);
  });
}
